export const SCREEN_MODES = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile'
};